import { useState } from 'react';
import { faqList } from '@/mocks/homeContent';
import SectionHead from './SectionHead';

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-50 py-12 md:py-16">
      <div className="container-x max-w-3xl">
        <SectionHead eyebrow="选号答疑" title="关于搭讪博主测评，常见问题" sub="这里集中回答读者最常问的几件事。" />

        <div className="flex flex-col gap-3">
          {faqList.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-soft"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-bold text-primary-600">
                        Q
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">{f.q}</span>
                    </span>
                    <i
                      className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform duration-300 ${isOpen ? 'rotate-45 bg-primary-500 text-background-50' : ''} ri-add-line`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {isOpen ? (
                  <div className="flex gap-3 border-t border-background-100 px-5 py-4">
                    <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-700">
                      A
                    </span>
                    <p className="text-sm leading-7 text-foreground-700">{f.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}